module.exports = __webpack_public_path__ + "img/schedule_inactive.d115aeb1.svg";